// export const validateEmail =(email)=>{
//     // Email regex pattern
//     const emailPattern = /^[^&?/]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        
//     // Check if the email matches the pattern
//     return (!emailPattern.test(email)||((email.match(/@/g) || []).length!==1)||(((email.match(/\./g) || []).length)!==1));
      
// }
// export const validateEmail = (email) => {
//     // Email regex pattern disallowing consecutive dots and a dot at the start and end of the domain
//     // eslint-disable-next-line security/detect-unsafe-regex
//     const emailPattern = /^[^,&?/]+@[a-zA-Z0-9]+(\.[a-zA-Z0-9]+)*\.[a-zA-Z]{2,}(?<!\.{2})(?<!\.)$/;

//     // Check if the email matches the pattern
//     // and if "@" is not at the beginning or end
//     return (
//         !emailPattern.test(email) ||
//         ((email.match(/@/g) || []).length !== 1) ||
//         (email.startsWith('@') || email.endsWith('@'))
//     );
// }


export const validateEmail = (email) => {
    // Simplified email regex pattern
    const emailPattern = /^[^&?/]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    // Check if the email matches the pattern
    return (!emailPattern.test(email) || ((email.match(/@/g) || []).length !== 1)) ||
     email.startsWith('@') || email.endsWith('@') || (email.match(/@/g) || []).length !== 1 || email.includes('/');
}